module.exports = __webpack_public_path__ + "img/typeText3.289da272.png";